import { styled } from "@mui/material/styles";

export const InnerContainer = styled("div")`
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: fill-available;
`;
